export {app as hirist} from './hirist/index';
export {app as iimjobs} from './iimjobs/index';
